import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	padding: 0 0.8rem 0.8rem;
`;

export const Inputs = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const Wrapper = styled.div`
	width: 100%;
	margin-top: 1rem;
`;
